import { Glif, type Oblik } from './Glif'

type Ton = 'success' | 'neutral' | 'error' | 'warning' | 'info'

export function Cip({
  ton,
  oblik,
  oznaka,
  testId,
}: {
  ton: Ton
  oblik: Oblik
  oznaka: string
  testId?: string
}) {
  return (
    <span className={`cip cip--${ton}`} data-testid={testId}>
      <Glif oblik={oblik} />
      {oznaka}
    </span>
  )
}

/** Status artikla iz kataloga (§B: artikal se ne briše, gasi se statusom). */
export function StatusArtikla({ status }: { status: 'aktivan' | 'neaktivan' }) {
  return status === 'aktivan' ? (
    <Cip ton="success" oblik="krug" oznaka="Aktivan" testId="status-artikla" />
  ) : (
    <Cip ton="neutral" oblik="crta" oznaka="Neaktivan" testId="status-artikla" />
  )
}
